module.exports = __webpack_public_path__ + "static/media/UM.804e19fd.png";